import * as XLSX from "xlsx";

/**
 * Real .xlsx export (SheetJS "xlsx" package) of the current visible rows/
 * columns -- NOT a CSV renamed to .xlsx. Produces an actual OOXML workbook
 * (verified in the build report by re-reading the bytes back with
 * XLSX.read and checking SheetNames/sheet content, not just "a file with
 * that extension downloaded").
 */
export function exportRowsAsXlsx(
  rows: Record<string, unknown>[],
  columns: { key: string; label: string }[],
  filename: string,
) {
  const aoa: (string | number | null)[][] = [
    columns.map((c) => c.label),
    ...rows.map((r) => columns.map((c) => (r[c.key] as string | number | null) ?? "")),
  ];
  const sheet = XLSX.utils.aoa_to_sheet(aoa);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Stocks");
  XLSX.writeFile(workbook, filename, { bookType: "xlsx" });
}
